// title  标题
// tabbar: true 底部导航栏展示
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader: true 没有顶部
export default [
  {
    path: "news",
    name: "news",
    meta: {
      title: "发现",
      tabbar: true,
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./News.vue"),
  },
  {
    path: "news/detail",
    name: "news.detail",
    meta: {
      title: "详情",
      unpull: true,
      noheader: true,
    },
    component: () => import("./NewsDetail.vue"),
  },
];
